// extracted by mini-css-extract-plugin
export default {"axis":"graph__axis___PyzHJ","hidden":"graph__hidden___pVe4u"};